// extracted by mini-css-extract-plugin
export var layout = "IntroDefault-module--layout--c7b59";
export var subtitle = "IntroDefault-module--subtitle--81b36";
export var details = "IntroDefault-module--details--b918f";
export var detailsItem = "IntroDefault-module--detailsItem--06c8f";
export var detailIcon = "IntroDefault-module--detailIcon--3aa9b";
export var animation = "IntroDefault-module--animation--5f1d5";